<template>
  <q-page class="container" padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold self-end">
        Cadastrar Chave
      </p>
    </div>

    <q-card>
      <q-card-section>
        <q-form ref="myForm">
          <div class="row col-12 q-col-gutter-sm">
            <div class="col-md-3 col-sm-12 col-xs-12">
              Chave nome:
              <q-input
                dense
                outlined
                v-model="chaveNome"
                label="Chave nome"
                :rules="[
                  (val) => (val && val.length > 0) || 'Campo Obrigatório',
                ]"
              >
                <template v-slot:prepend>
                  <q-icon name="person" />
                </template>
              </q-input>
            </div>

            <div class="col-md-3 col-sm-12 col-xs-12">
              ClienteId:
              <q-select
                dense
                outlined
                v-model="clienteSelected"
                use-input
                label="ClienteId"
                hide-selected
                fill-input
                input-debounce="0"
                :options="listaClientes"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey"
                      >Nenhum Resultado</q-item-section
                    >
                  </q-item>
                </template>
              </q-select>
            </div>

            <div class="col-md-1 col-sm-12 col-xs-12">
              <p></p>
              <q-btn
                class="q-mt-sm full-width"
                color="positive"
                label="Criar"
                no-caps
                icon="add"
                @click.prevent="cadastrarChave"
              />
            </div>
          </div>
        </q-form>
      </q-card-section>
    </q-card>

    <div class="q-pt-md">
      <q-table
        title="Chaves Cadastradas"
        :rows="listaChaves"
        :columns="columns"
        row-key="name"
        class="tabela-tamanho-fixo"
        :rows-per-page-options="[0]"
        dense
      >
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td class="text-left" key="clienteId" :props="props">{{
              props.row.clienteId
            }}</q-td>
            <q-td class="text-left" key="nome" :props="props">{{
              props.row.nome
            }}</q-td>
            <q-td class="text-left" key="apiKey" :props="props">{{
              props.row.apiKey
            }}</q-td>
            <q-td class="text-left" key="apiSecret" :props="props">
              <q-input
                v-model="props.row.apiSecret"
                borderless
                :readonly="true"
                :type="isPwd ? 'password' : 'text'"
              >
                <template v-slot:append>
                  <q-icon
                    :name="isPwd ? 'visibility_off' : 'visibility'"
                    class="cursor-pointer"
                    @click="isPwd = !isPwd"
                  />
                </template>
              </q-input>
            </q-td>
            <q-td class="text-center" key="roles" :props="props">
              <q-select borderless :options="props.row.roles" />
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
//import { useRoute } from "vue-router";
import { useQuasar } from "quasar";

const columns = [
  {
    name: "clienteId",
    align: "left",
    label: "clienteId",
    field: "clienteId",
    sortable: true,
  },
  {
    name: "nome",
    align: "left",
    label: "nome",
    field: "nome",
    sortable: true,
  },
  {
    name: "apiKey",
    align: "left",
    label: "apiKey",
    field: "apiKey",
    sortable: true,
  },
  {
    name: "apiSecret",
    align: "left",
    label: "apiSecret",
    field: "apiSecret",
    sortable: true,
  },
  {
    name: "roles",
    align: "center",
    label: "roles",
    field: "roles",
    sortable: true,
  },
];

export default {
  name: "DetalheCliente",
  setup() {
    const store = useStore();
    const clienteSelected = ref("staging-multpex");
    const listaClientes = ref([]);
    const chaveNome = ref("");
    const $q = useQuasar();
    const listaChaves = ref([]);

    const getChaveCliente = async () => {
      try {
        let resposta = await store.dispatch("office/buscarChaves", {
          clienteId: clienteSelected.value,
        });

        listaChaves.value = resposta.data.resultado.dados;
      } catch (error) {
        console.error(error);
        $q.notify({
          message: "Erro a tentar buscar chaves",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const cadastrarChave = async () => {
      try {
        await store.dispatch("office/cadastrarChave", {
          clienteId: clienteSelected.value,
          nome: chaveNome.value,
        });

        $q.notify({
          message: "Chave de acesso cadastrada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getChaveCliente();
      } catch (error) {
        $q.notify({
          message: error.response.data.erro.detalhes[0].clienteId,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getClients = async () => {
      try {
        let resposta = await store.dispatch("office/listarCliente");

        resposta.listaClientes.forEach((e) => {
          listaClientes.value.push(e.clienteId);
        });
      } catch (error) {
        console.error(error);
      }
    };

    onMounted(getClients);
    onMounted(getChaveCliente);

    watch(
      () => clienteSelected.value,
      () => {
        getChaveCliente();
      }
    );

    return {
      columns,
      listaChaves,
      clienteSelected,
      getClients,
      listaClientes,
      isPwd: ref(true),
      cadastrarChave,
      chaveNome,
      getChaveCliente,
    };
  },
};
</script>
